import { memo } from 'react';

import { CreditUsageBreakdownCategory } from '~/components/CreditUsageMeter/CreditUsageBreakdownCategory';
import { type CreditUsageStats } from '~/components/CreditUsageMeter/types';
import {
  CREDIT_USAGE_CATEGORIES,
  getDisplayCategoryUsage,
  getStorageDisplayCategory,
  shouldRenderDisplayCategory,
} from '~/components/CreditUsageMeter/utils';

export type CreditUsageBreakdownCategoryListProps = {
  hasAiAddons: boolean;
  isCreditModel: boolean;
  used: CreditUsageStats['used'];
};

export const CreditUsageBreakdownCategoryList = memo(
  ({ hasAiAddons, isCreditModel, used }: CreditUsageBreakdownCategoryListProps) => (
    <>
      {CREDIT_USAGE_CATEGORIES.map((category) => {
        const usage = getDisplayCategoryUsage(used, category);

        if (!shouldRenderDisplayCategory({ category, usage, isCreditModel })) {
          return null;
        }

        const displayCategory = category === 'generative' ? category : getStorageDisplayCategory(hasAiAddons);

        return <CreditUsageBreakdownCategory key={category} category={displayCategory} {...usage} />;
      })}
    </>
  ),
);

CreditUsageBreakdownCategoryList.displayName = 'CreditUsageBreakdownCategoryList';
